<template>
  <div class="top-banner-wrap" :class="{ 'is-closed': !isBannerOpen }">
    <div class="inner">
      <ul class="banner-list">
        <li v-for="(item, index) in props.bannerList" :key="index" class="banner-li">
          <NuxtLink :to="item.nwinMvYn === 'N' ? item.link : ''" class="banner-link" @click.prevent="moveBannerPage(item.bnnrSeq, item.nwinMvYn, item.link)">{{ item.text }}</NuxtLink>
        </li>
      </ul>
      <button @click="isBannerOpen = false" class="btn-close" aria-label="닫기"></button>
    </div>
  </div>
</template>
<script lang="ts" setup>
export interface BannerItem {
  text: string
  link: string
  nwinMvYn: string
  bnnrSeq: number
}

interface Props {
  bannerList?: BannerItem[]
}

const props = withDefaults(defineProps<Props>(), {
  bannerList: () => [{ text: '', link: '/', nwinMvYn: '', bnnrSeq: 0 }]
})

const fetchBuilder = useHconFetchBuilder();
const router  = useRouter();

// 팝업
const {
  showAlert
} = usePopup();


// 배너 클릭 시 클릭횟수 업데이트 및 화면 제어 (새창이동 또는 화면 전환)
const moveBannerPage = async (bnnrSeq: number, nwinMvYn: string, link: string) => {
  const res = await fetchBuilder
  .put<AjaxResult<void>>(`/api/v1/product/display/banner-click-count/${bnnrSeq}`)
  .build()
  .execute()
  .then(async (result) => {
    if(result.resultCode != '200') {
      showAlert(result.resultMessage);
    } else {
      if (nwinMvYn === 'Y') {
        // 새 창으로 이동
        window.open(link, '_blank');
      } else {
        router.push(link);
      }
    }
  })
}

// 배너 닫기
const isBannerOpen = ref(true)
</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/display-hcon.scss" as *;
</style>